module.exports = __webpack_public_path__ + "static/media/change-password.6e18a9d8.jpg";